import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  clearState,
  selectedVisitDetails,
  latestNoteStatus,
  latestNoteStatusFailed,
} from './selectedVisitUtils';
import {
  selectedVisitInitialStateValue,
  selectedVisitSliceName,
} from './selectedVisitInitialState';
import { REMINDER_AVAILABILITY } from '@ax/constants';
import { loadVisitsSucceeded } from '../visits';
import { LoadVisitsPayload } from '../visits/interfaces';

export const selectedVisitSlice = createSlice({
  name: selectedVisitSliceName,
  initialState: selectedVisitInitialStateValue,
  extraReducers: (builder) => {
    builder.addCase(loadVisitsSucceeded, (state, action: PayloadAction<LoadVisitsPayload>) => {
      const selectedVisit = action.payload.visits?.find((visit) => visit.uuid === state.uuid);

      if (!selectedVisit) {
        return { ...state };
      }

      return {
        ...state,
        ...selectedVisit,
      };
    });
  },
  reducers: {
    setSelectedVisitDetails: selectedVisitDetails,
    loadLatestNoteStatusSucceeded: latestNoteStatus,
    loadLatestNoteStatusFailed: latestNoteStatusFailed,
    clearVisitDetails: clearState,
    reminderAvailabilityUpdated(
      state,
      action: PayloadAction<{ noteId: string; reminderAvailability: REMINDER_AVAILABILITY }>,
    ) {
      if (state.uuid !== action.payload.noteId) {
        return { ...state };
      }

      return {
        ...state,
        reminderAvailability: action.payload.reminderAvailability,
      };
    },
    reminderAvailabilityUpdateFailed(
      state,
      _: PayloadAction<{
        error: Error;
        message: string;
        noteId: string;
        reminderAvailability: REMINDER_AVAILABILITY;
      }>,
    ) {
      return { ...state };
    },
  },
});

export const {
  setSelectedVisitDetails,
  clearVisitDetails,
  loadLatestNoteStatusSucceeded,
  loadLatestNoteStatusFailed,
} = selectedVisitSlice.actions;

export default selectedVisitSlice.reducer;
